/**
 * Кнопка «Купуйте зараз».
 *
 * Тема ховає рідну кнопку Shopify правилом [data-shopify="payment-button"]{display:none}
 * і показує замість неї власну, з потрібним текстом і стилем. Але та кнопка —
 * type="button" без жодного обробника, тож клік по ній не робив нічого.
 *
 * Цей файл вішає на неї поведінку: додає товар у кошик і веде на checkout
 * (для України — на свій чекаут або Chekly).
 * Навмисно окремим файлом, а не правкою product.js: якщо тут щось впаде,
 * решта логіки товарної сторінки (вибір варіантів, галерея) не постраждає.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-buy-now]';

  function routes() {
    return (window.theme && window.theme.routes) || {};
  }

  function checkoutUrl() {
    var root = routes().root_url || '/';
    return root.replace(/\/+$/, '') + '/checkout';
  }

  // Покупців з України веде на свій чекаут (ADR-0065), якщо цей браузер потрапив у його частку,
  // інакше на Chekly (ADR-0064). Обидва скрипти ловлять лише кліки по кнопках оформлення,
  // а сюди ми переходимо самі, тож кличемо їхній перехід напряму. Обидва беруть увесь кошик.
  function goToCheckout() {
    var own = window.turbotaCheckout;
    if (own && typeof own.shouldUse === 'function' && own.shouldUse()) {
      own.start(null);
      return;
    }
    var chekly = window.cheklyCheckoutManager;
    var isUA = window.Shopify && window.Shopify.country === 'UA';
    if (isUA && chekly && chekly.functions && typeof chekly.functions.processCheckout === 'function') {
      chekly.functions.processCheckout();
      return;
    }
    window.location.href = checkoutUrl();
  }

  function showError(form, message) {
    var host = form.closest('product-form') || form.parentElement;
    var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
    var target = wrapper && wrapper.querySelector('.product-form__error-message');

    if (wrapper && target) {
      target.textContent = message || 'Не вдалося оформити покупку. Спробуйте ще раз.';
      wrapper.removeAttribute('hidden');
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    window.alert(message || 'Не вдалося оформити покупку. Спробуйте ще раз.');
  }

  function onClick(event) {
    event.preventDefault();

    var button = event.currentTarget;
    if (button.classList.contains('loading')) return;

    var form = button.closest('form[action*="/cart/add"]') || button.closest('form');
    if (!form) {
      console.error('[buy-now] не знайдено форму товару');
      return;
    }
    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    // <product-form> вмикає це поле у своєму конструкторі. Якщо кастомний елемент
    // ще не піднявся, поле лишається disabled і варіант не потрапить у запит.
    var variantInput = form.querySelector('[name="id"]');
    if (variantInput) variantInput.disabled = false;

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    fetch(routes().cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Shopify віддає поле status лише тоді, коли додати не вдалося.
        if (data && data.status) {
          showError(form, data.description || data.message);
          return;
        }
        goToCheckout();
      })
      .catch(function (error) {
        console.error('[buy-now]', error);
        showError(form, null);
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  }

  function bind() {
    document.querySelectorAll(SELECTOR).forEach(function (button) {
      if (button.dataset.buyNowBound === '1') return;
      button.dataset.buyNowBound = '1';
      button.addEventListener('click', onClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Тема перерендерює секції після зміни варіанта — переприв'язуємось.
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('variant:change', bind);
})();
